import T from 'prop-types';

export default T.shape({
  id: T.number,
  username: T.string,
  email: T.string,
  profile_color: T.string,
  birthdate: T.string,
  gender: T.string
});



// WEBPACK FOOTER //
// ./src/shapes/user.js